module.exports = __webpack_public_path__ + "img/right_teacher.aa7cf07c.png";